import { OptionsSliceState } from '@/state/slices/options/typings';
import EntryPointsHelper from '@/utils/entry-points-helper';
import { NaasEvent } from '@/utils/naas-helper/enum';
import { EnvVarsService } from '@multitenancy-spa/env-vars-service/esm/services/env-vars-service';

class NaasHelperClass {
	private static _instance: NaasHelperClass;

	public static get instance(): NaasHelperClass {
		if (!NaasHelperClass._instance) {
			NaasHelperClass._instance = new NaasHelperClass();
		}

		return NaasHelperClass._instance;
	}

	public getEntryPointData(
		dataAttr?: string,
	): boolean | undefined | string | number {
		if (!dataAttr) return;

		const entryPoint = EntryPointsHelper.entryPoint;
		if (!entryPoint) return;

		const dataValue = entryPoint.dataset[dataAttr];
		if (!dataValue) return;

		return this.castDataValue(dataValue);
	}

	public getEntrypointDataset(): OptionsSliceState {
		const initialDataset: OptionsSliceState = {
			disableFullyQualifyDxLinks: true,
			disableSearch: true,
			disableYourRetailer: true,
			disableRetailerLocatorLink: true,
			disableBuildsMenu: true,
			enableLanguageSelectorLink: true,
			enableBuildCountApi: false,
			enableMyJLRProfile: false,
			enableMrp: false,
			hostDomain: '',
			thirdParty:
				EnvVarsService.getVar('VITE_THIRD_PARTY', true) ?? false,
			buildCountEnabled:
				EnvVarsService.getVar('VITE_BUILD_COUNT_ENABLED', true) ??
				false,
		};

		const entryPoint = EntryPointsHelper.entryPoint;
		if (!entryPoint) return initialDataset;

		const extracedDataset = Object.entries(entryPoint.dataset).reduce(
			(acc, [key, value]) => {
				acc[key] = this.castDataValue(value);
				return acc;
			},
			initialDataset,
		);

		return extracedDataset;
	}

	public dispatchEvent(
		eventType: NaasEvent,
		detail: Record<string, any> = {},
	) {
		const entryPoint = EntryPointsHelper.entryPoint;
		if (!entryPoint) return;

		const event = new CustomEvent(eventType, { detail });
		entryPoint.dispatchEvent?.(event);
	}

	private castDataValue(
		dataValue?: string,
	): boolean | undefined | string | number {
		// cast undefined
		if (!dataValue || dataValue === 'undefined') {
			return undefined;
		}

		// cast boolean
		if (dataValue === 'true') return true;
		if (dataValue === 'false') return false;

		// numeric cast
		const numericValue = Number(dataValue);
		if (!isNaN(numericValue)) return numericValue;

		return dataValue;
	}
}

const NaasHelper = NaasHelperClass.instance;

export { NaasHelperClass };
export default NaasHelper;
